import { DateTime } from "effect"

export function getSubscriptionStatusColor(status: string): string {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800"
    case "trialing":
      return "bg-blue-100 text-blue-800"
    case "past_due":
      return "bg-yellow-100 text-yellow-800"
    case "canceled":
    case "incomplete_expired":
      return "bg-red-100 text-red-800"
    case "incomplete":
    case "unpaid":
      return "bg-orange-100 text-orange-800"
    case "paused":
      return "bg-gray-100 text-gray-800"
    default:
      return "bg-gray-100 text-gray-800"
  }
}

export function getInvoiceStatusColor(status: string): string {
  switch (status) {
    case "paid":
      return "bg-green-100 text-green-800"
    case "open":
      return "bg-blue-100 text-blue-800"
    case "draft":
      return "bg-gray-100 text-gray-800"
    case "void":
      return "bg-red-100 text-red-800"
    case "uncollectible":
      return "bg-orange-100 text-orange-800"
    default:
      return "bg-gray-100 text-gray-800"
  }
}

const CURRENCY_LOCALE: Record<string, string> = {
  AUD: "en-AU",
  NZD: "en-NZ",
  GBP: "en-GB"
}

export function formatBillingCurrency(amountCents: number, currency: string): string {
  const upperCurrency = currency.toUpperCase()
  return new Intl.NumberFormat(CURRENCY_LOCALE[upperCurrency] ?? "en-AU", {
    style: "currency",
    currency: upperCurrency
  }).format(amountCents / 100)
}

export function formatBillingDate(date: DateTime.Utc): string {
  return new Intl.DateTimeFormat("en-AU", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }).format(DateTime.toDate(date))
}

export function getSubscriptionStatusLabel(status: string): string {
  switch (status) {
    case "active":
      return "Active"
    case "past_due":
      return "Payment overdue"
    case "canceled":
      return "Cancelled"
    case "trialing":
      return "Trial"
    case "unpaid":
      return "Unpaid"
    case "incomplete":
      return "Setup incomplete"
    case "incomplete_expired":
      return "Expired"
    case "paused":
      return "Paused"
    default:
      return status
  }
}
